import React, { useState, useRef, useEffect } from "react";
import Styles from "../../../assets/css/Blogs/PerfectGiftsGuide/AdvancedDrone.module.css";
import { useGlobalState } from "../../../Functions/GlobalStates";
import debounce from "lodash.debounce";
import Loading from "../../Loadings/Loading";
import { Helmet } from "react-helmet-async";

const AdvancedDrone = () => {
  // States Here
  const [IsLoaded, setIsLoaded] = useState(false); // I CAN use this to show loading before all images loads
  // Global States Here //////////////////////////////////////////////////////...............................
  const {
    CheckPage,
    setCheckPage,
    DontAllow,
    setDontAllow,
    PagesWidthHeight,
    setPagesWidthHeight,
  } = useGlobalState();

  // React Elements References Here //////////////////////////////////// ...............
  const CheckPageStateRef = useRef(false); // Ref for the check Page
  const AdvancedDrone = useRef(false); // Ref for the absolute box

  const ProductImages = require.context(
    "../../../assets/images/Blogs/PerfectGiftsGuide/AdvancedDrone/Ai-Images",
    false,
    /\.(png|jpe?g|gif|bmp|webp|svg|avif)$/
  );
  const ProductImagesArray = [
    ProductImages("./1.avif"),
    ProductImages("./2.avif"),
    ProductImages("./3.avif"),
    ProductImages("./4.avif"),
    ProductImages("./8.avif"),
  ];

  // Show And Hide Navbar DropMenu HomePage
  useEffect(() => {
    const handleCheckResize = () => {
      if (!CheckPageStateRef.current) {
        CheckPageStateRef.current = true;
        setCheckPage(true);
        setDontAllow(true);
      }
      // console.log("oN Mount", CheckPageStateRef.current);
      // console.log("Mounted User Entered");
    };
    handleCheckResize(); // call on mount

    // Add the resize event listener
    window.addEventListener("resize", handleCheckResize);

    // Update global state when the component unmounts , It mean when The user Leaves This Page
    return () => {
      if (CheckPageStateRef.current) {
        CheckPageStateRef.current = false;
        setCheckPage(true);
        setDontAllow(false);
      }
      // console.log("oN unMOUNT", CheckPageStateRef.current);
      // console.log("Unmounted User Leaved");
      window.removeEventListener("resize", handleCheckResize);
    };
  }, []);

  // Preload Images Before render it will help to descrease flickers on img change
  useEffect(() => {
    const preloadImages = async (imageArray, callback) => {
      try {
        await Promise.all(
          imageArray.map((src) => {
            return new Promise((resolve, reject) => {
              const img = new Image();
              img.src = src;
              img.onload = resolve;
              img.onerror = reject; // Add error handling
            });
          })
        );
        callback(); // Callback after all images are preloaded
      } catch (error) {
        console.error("Error preloading image:", error);
      }
    };

    preloadImages([ProductImagesArray[4]], () => {
      setIsLoaded(true); // Set state when all images are loaded
      // console.log("All Images Are Loaded");
    });
  }, []);

  // updating height to modify Navbar DropMenu height
  useEffect(() => {
    const updateSize = () => {
      if (AdvancedDrone.current) {
        const { width, height } = AdvancedDrone.current.getBoundingClientRect();
        setPagesWidthHeight((prev) => ({
          ...prev,
          height: parseFloat(height.toFixed(1)),
        }));
      }
    };

    updateSize(); // Run once on mount
    // Debounce Will Help Derease the Consuption of the Ram & Limit Bulk re-Runing Funtions in a Sec
    const updateSizeDelay = debounce(updateSize, 100);
    window.addEventListener("resize", updateSize);
    window.addEventListener("scroll", updateSizeDelay);

    // Cleanup function to remove event listener when component unmounts
    return () => {
      window.removeEventListener("resize", updateSize);
      window.removeEventListener("scroll", updateSizeDelay);
    };
  }, []); // Empty dependency array to run only on mount and unmount

  return IsLoaded ? (
    // Placeholder for position absoluted div that helps accupy the space of absoluted positioned div
    <>
      <Helmet>
        {/* Title Tag: Displayed in browser tabs and search results */}
        <title>4K Drone – Best Gift for Tech Lovers 🚁</title>

        {/* Meta Description: A concise summary for search engines */}
        <meta
          name="description"
          content="4K drone with smart controls, long-range, and stunning aerial shots. Perfect gift for adventure lovers!"
        />

        {/* Meta Keywords: Helps with search engine indexing (use sparingly) */}
        <meta
          name="keywords"
          content="4K drone, drone gift, smart drone, tech gadgets 2024, aerial photography, adventure gear"
        />

        {/* Viewport: Ensures proper scaling on mobile devices */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph Tags: Enhance social media sharing */}
        <meta
          property="og:title"
          content="4K Drone – Best Gift for Tech Lovers 🚁"
        />
        <meta
          property="og:description"
          content="4K drone with smart controls, long-range, and stunning aerial shots. Perfect gift for adventure lovers!"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://affiliators.netlify.app/#/PerfectGiftsGuide/advanceddrone"
        />
        {/* <meta property="og:image" content="/images/AdvancedDrone/9.png" /> */}

        {/* Twitter Card Tags: Enhance Twitter sharing with a large summary image */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="4K Drone – Best Gift for Tech Lovers 🚁"
        />
        <meta
          name="twitter:description"
          content="4K drone with smart controls, long-range, and stunning aerial shots. Perfect gift for adventure lovers!"
        />
        {/* <meta name="twitter:image" content="/images/AdvancedDrone/9.png" /> */}

        {/* Robots Tag: Instructs search engines to index this page and follow its links */}
        <meta name="robots" content="index, follow" />

        {/* Canonical Link: Prevents duplicate content issues by specifying the preferred URL */}
        {/* <link
          rel="canonical"
          href="https://affiliators.netlify.app/#/PerfectGiftsGuide/advanceddrone"
        /> */}

        {/* Additional SEO Optimization */}
        <meta name="author" content="Zeeshan Ahmad Kamran" />
        <meta name="language" content="en" />
        <meta http-equiv="Content-Language" content="en" />
      </Helmet>

      <div ref={AdvancedDrone} className={Styles.AdvancedDroneContainer}>
        <section className={Styles.AdvancedDroneSection1}>
          <div className={Styles.AdvancedDroneSection1Text1Container}>
            {/* <h1>Powerful Compact Spotlight for Every Adventure 🌟</h1> */}
          </div>
          <img
            src={`${ProductImagesArray[4]}`}
            alt="Advanced Drone"
            title="This is an AI-generated representation. Actual product may vary."
          />
          <p>
            These images are AI-generated representations of the products.
            Actual appearance, specifications, features, and colors may vary.
            For the most accurate and up-to-date product details, please refer
            to the official product page via the button at the end of this blog.
          </p>
          <div className={Styles.AdvancedDroneSection1Text2Container}>
            <h1>| Advanced Drone |</h1>
            <h1>Why It's the Best Gift for Loved Ones 🎁</h1>
            <p>
              This drone is an excellent choice for hobbyists and professionals
              alike. Whether capturing stunning landscapes or enjoying immersive
              FPV flights, it enhances creativity and excitement. Its
              intelligent flight features ensure ease of use for beginners while
              offering pro-level control for experts.
            </p>
          </div>
          <div className={Styles.AdvancedDroneSection1Img2Container}>
            <img
              src={`${ProductImagesArray[1]}`}
              alt="Advanced Drone"
              title="This is an AI-generated representation. Actual product may vary."
            />
            <img
              src={`${ProductImagesArray[0]}`}
              alt="Advanced Drone"
              title="This is an AI-generated representation. Actual product may vary."
            />
          </div>
          <div className={Styles.AdvancedDroneSection1Text3Container}>
            <h1>How Advanced Technology Drones Stand Out</h1>
            <p>
              <span style={{ color: "black" }}>Cinematic Camera Quality </span>{" "}
              ✅ Capture breathtaking 4K footage with advanced imaging
              technology.
            </p>
            <p>
              <span style={{ color: "black" }}>Extended Flight Time</span> ✅
              Fly longer with powerful batteries for uninterrupted shots.
            </p>
            <p>
              <span style={{ color: "black" }}>Smart Obstacle Avoidance</span>{" "}
              ✅ Navigate safely with intelligent sensors that detect obstacles.
            </p>
            <p>
              <span style={{ color: "black" }}>Professional Features</span> ✅
              Supports high-resolution video formats for superior
              post-production.
            </p>
            <p>
              <span style={{ color: "black" }}>Seamless Control</span> ✅ Enjoy
              real-time transmission and effortless maneuverability.
            </p>
          </div>
          <div className={Styles.AdvancedDroneSection1Img3Container}>
            <img
              src={`${ProductImagesArray[2]}`}
              alt="Advanced Drone"
              title="This is an AI-generated representation. Actual product may vary."
            />
            <img
              src={`${ProductImagesArray[3]}`}
              alt="Advanced Drone"
              title="This is an AI-generated representation. Actual product may vary."
            />
          </div>
          <div className={Styles.AdvancedDroneSection1Text4Container}>
            <h1>Make Every Flight an Adventure ✨</h1>
            <p>
              Drones aren’t just for capturing photos; they redefine how we
              explore the world. With advanced AI, precise controls, and
              cinematic quality, every flight becomes an unforgettable
              experience. Whether for work or play, this drone will elevate your
              creativity and open up new possibilities.
            </p>
          </div>
          <div className={Styles.AdvancedDroneSection1Text5Container}>
            <h4>
              🔔 If you're interested, similar products are available through
              the provided sources.
            </h4>
          </div>
          <a
            title="This link leads to an affiliate product page. We may earn a commission at no extra cost to you."
            href="https://amzn.to/3X4mkM6"
            target="_blank"
            rel="noopener noreferrer"
            className={Styles.AdvancedDroneSection1BtnAmazonAncherContainer}
          >
            <button
              title="This button leads to an affiliate product page. We may earn a commission at no extra cost to you."
              className={Styles.AdvancedDroneSection1BtnAmazon}
            >
              Buy Now on <span>&nbsp;&nbsp;Amazon</span> <span>&nbsp;»</span>
            </button>
          </a>
          <div className={Styles.AdvancedDroneSection1DesclaimerContainer}>
            <h1>Affiliate Disclaimer 💬</h1>
            <p>
              As an Amazon Associate, I earn from qualifying purchases. This
              helps support the blog at no extra cost to you.
            </p>
            <h1>AI-Generated Images Disclaimer</h1>
            <p>
              The product images on this site are AI-generated representations
              created for illustrative purposes only. They may not perfectly
              match the actual product in terms of color, design, or features.
              For accurate details and images, please refer to the official
              product listing on Amazon by clicking the provided links.
            </p>
            <h1>HashTags</h1>
            <p>
              #DronePhotography #TechGift #AerialShots #4KVideo
              #FlyingExperience #SmartDrones #PhotographyTools #GadgetLover
              #ProfessionalDrones #LongRangeDrone
            </p>
            <h1>Keywords</h1>
            <p>
              Top drones for beginners and professionals High-quality drone for
              content creators Aerial photography drone with stabilization Best
              drones for cinematic shots Affordable drones with advanced
              features Long-range drones with live video transmission Best gift
              drones for tech lovers
            </p>
          </div>
        </section>
      </div>
    </>
  ) : (
    <Loading />
  );
};

export default AdvancedDrone;
